import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import LoanTable from "./LoanTable";
import {
  CONSTANTS,
  filterLoanHistoryByItem,
  getBackCardLoanRecords,
  transformLoansToRecords,
} from "../utils/bookCardUtils";

const BookCardBack = ({
  loanHistory = [],
  selectedItemId,
  currentBookCard = 0,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  // Reset pagination when book card changes
  useEffect(() => {
    setCurrentPage(1);
  }, [currentBookCard]);

  // Filter loans for the selected item using utility function
  const filteredLoans = filterLoanHistoryByItem(loanHistory, selectedItemId);

  // Get loan records for this book card's back using utility function
  const backCardLoans = getBackCardLoanRecords(filteredLoans, currentBookCard);

  // Transform loan data into standardized records using utility function
  const loanRecords = transformLoansToRecords(backCardLoans);

  // Pagination logic
  const totalPages =
    Math.ceil(loanRecords.length / CONSTANTS.BACK_CARD_RECORDS) || 1;

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        border: "2px solid #333",
        padding: "0px",
        borderRadius: "6px",
        width: "500px",
        height: "720px",
        margin: "-6px auto",
        fontFamily: "Arial, sans-serif",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <LoanTable
        loanRecords={loanRecords}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        rowsPerPage={CONSTANTS.BACK_CARD_RECORDS}
      />
    </div>
  );
};

const LoanHistoryPropType = PropTypes.arrayOf(
  PropTypes.shape({
    patron: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      full_name: PropTypes.string,
      year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      program: PropTypes.string,
    }),
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    checkout_date: PropTypes.string,
    due_date: PropTypes.string,
    return_date: PropTypes.string,
    item_pid: PropTypes.string,
    item: PropTypes.object,
  })
);

BookCardBack.propTypes = {
  loanHistory: LoanHistoryPropType,
  selectedItemId: PropTypes.string,
  currentBookCard: PropTypes.number,
};

export default BookCardBack;
